// extracted by mini-css-extract-plugin
export default {"wrapper":"logo_wrapper__kAKUj","image":"logo_image__dG-Z6"};